import React, { Suspense, lazy, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { CToast, CToastBody, CToastClose, CToaster } from '@coreui/react'
import { wtLoadLoggedInData } from 'src/helpers/commons/utils'
import { wtGetFromLocalStorage } from 'src/helpers/commons/LocalStorage'
import { Navigate } from 'react-router-dom'
import EmployeeDataReport from '../EmployeeDataReport'
import { wtHrefHashGetVars } from 'src/helpers/commons/HrefHash'
import { lzNotifyErrorMessageFromResult } from 'src/helpers/commons/notifications'
import DesignationTrackingReport from '../DesignationTrackingReport'
import EmployeeHierarchy from '../../views/EmployeeHierarchy/EmployeeHierarchy'
import EmployeeDetailedDataReport from '../EmployeeDetailedDataReport'
import Loading from 'src/helpers/commons/loader'
import EmployeeOnMoveReport from '../EmployeeOnMoveReport'
import EmployeeAttendanceReport from '../EmployeeAttendanceReport'
import EmployeeAttendanceDifferenceReport from '../EmployeeAttendanceDifferenceReport'
import EmployeeLateComingReport from '../EmployeeLateComingReport'
import EmployeeEarlyGoingReport from '../EmployeeEarlyGoingReport'
import EmployeePerformanceEvaluationReport from '../EmployeePerformanceEvaluationReport'
import AttendanceAnalysisReport from '../AttendanceAnalysisReport'
import AttendanceAnalysisOfficersReport from '../AttendanceAnalysisOfficersReport'
import LeaveReport from '../LeaveReport'
import TrialBalance from '../TrialBalance'
import TrailBalanceV2 from '../TrialBalanceV2'
import AccountStatement from '../AccountStatement'
import BalanceSheet from '../BalanceSheet'
import ProfitAndLoss from '../ProfitAndLoss'
import ProfitAndLossVersion2 from '../ProfitAndLossVersion2'
import ProfitAndLossSurcharge from '../ProfitAndLossSurcharge'
import GroupBalance from '../GroupBalance'
import EmployeePerformanceEvaluationDetailedReport from '../EmployeePerformanceEvaluationDetailedReport'
import VehicleLogReport from '../VehicleLogReport'
import OvertimeReport from '../OvertimeReport'
import EmployeeFamilyDetailReport from '../EmployeeFamilyDetailReport'
import EmployeeLeaveDetailReport from '../EmployeeLeaveDetailReport'
import EvaluationSummaryReport from '../EvaluationSummaryReport'
import VehicleTrackingReport from '../VehicleTrackingReport/VehicleTrackingReport'
import VehicleTrackingDetailsReport from '../VehicleTrackingReport/VehicleTrackingDetails'
import FinanceDashboard from '../FinanceDashboard'
import ManagementDashboard from '../ManagementDashboard'
import VisitorsManagementDetailDashboard from '../VisitorsManagementDetailDashboard'
import VisitorsReport from '../VisitorsReport'
import EmployeeBonusOnMeritReport from '../EmployeeBonusOnMeritReport'
import GrossProfitSheet from '../GrossProfitSheet'
import GpReport from '../GpReport'
import BankBalanceReport from '../BankBalanceReport'
import CashFlowStatement from '../CashFlowStatement'
import StockAdjustmentReport from '../StockAdjustmentReport'
import SalesTargetReport from '../SalesTargetReport'
import OutletExpenseReport from '../OutletExpenseReport'
import JVReport from '../JVReport'
import UntaggedReceiptsReport from '../UntaggedReceiptsReport'
import JoiningReport from '../JoiningReport'
import LeavingReport from '../LeavingReport'
import ContractExpiryReport from '../ContractExpiryReport'
import HrReport from '../HrReport'
import OpdReport from '../OpdReport/index'
import ProjectCashFlow from '../ProjectCashFlow'
import SalaryPaymentReport from '../SalaryPaymentReport'
import WppfReport from '../WppfReport'
import SaleOrderReport from '../SaleOrderReport'
import SaleOrderDetailReport from '../SaleOrderDetailReport'
import SaleOrderDeliveryReport from '../SaleOrderDeliveryReport'
import SaleOrderDeliveryDetailReport from '../SaleOrderDeliveryDetailReport'
import RatioAnalysis from '../RatioAnalysis'
import RatioAnalysisV1 from '../RatioAnalysisV1'
import ChequeSigningReport from '../ChequeSigningReport'
import SalesDashboard from '../SalesDashboard'
import EmployeeSalariesReport from '../EmployeeSalariesReport'
import StockReport from '../StockReport'
import OutletWiseStockReport from '../OutletWiseStockReport'
import StockSerialDeliveryComparisonReport from '../StockSerialDeliveryComparisonReport'
import ItemBarcodes from 'src/widgets/Barcodes/ItemBarcodes'
import EmployeeWarningReport from '../EmployeeWarningReport'
import EmployeeTrainingReport from '../EmployeeTrainingReport'
import EmployeeTransferReport from '../EmployeeTransferReport'
import BranchTrackingReport from '../BranchTrackingReport'
import ProjectDetailReport from '../ProjectDetailReport'
import CwipClassificationProjectDetailReport from '../CwipClassificationProjectDetailReport'
import TalentPoolReport from '../TalentPoolReport'
import SaleBookReport from '../SaleBookReport'
import SaleSummaryReport from '../SaleSummaryReport'
import DebtorsReport from '../DebtorsReport'
import ItemSerialReport from '../ItemSerialReport'
import StockDetailedReport from '../StockDetailedReport'
import StockAgingReport from '../StockAgingReport'
import StockAgingReportV2 from '../StockAgingReportV2'
import ItemIssuanceReport from '../ItemIssuanceReport'
import GrnReport from '../GrnReport'
import SaleOrderInvoiceDetailReport from '../SaleOrderInvoiceDetailReport'
import StockMovementSummaryReport from '../StockMovementSummaryReport'
import ItemReport from '../ItemReport'
import PartiesReport from '../PartiesReport'
import ItemLedgerReport from '../ItemLedgerReport'
import CustomerLedgerReport from '../CustomerLedgerReport'
import MembersReport from '../MembersReport'
import ShootingMonthlyInvoiceReport from '../ShootingMonthlyInvoiceReport/ShootingMonthlyInvoiceReport'
import IncomeTaxReport from '../IncomeTaxReport'
import InternshipReport from '../InternshipReport'
import InternalRequisitionReport from '../InternalRequisitionReport'
import EmployeeAbsentReport from '../EmployeeAbsentReport'

const HRDashboard = lazy(() => import('../HRDashboard'))

export default function Reports({ authToken }) {
  const [reportCode, setReportCode] = useState('')
  const [reportParams, setReportParams] = useState('')
  const errorMessages = useSelector((state) => state.errorMessages)
  const successMessages = useSelector((state) => state.successMessages)

  const discardErrorMsg = (dex) => {
    const reduxDispatch = window.reduxStore.dispatch
    const msgs = errorMessages.slice()
    msgs.splice(dex, 1)
    reduxDispatch({ type: 'set', errorMessages: msgs })
  }

  const discardSuccessMsg = (dex) => {
    const reduxDispatch = window.reduxStore.dispatch

    const msgs = successMessages.slice()
    msgs.splice(dex, 1)
    reduxDispatch({ type: 'set', successMessages: msgs })
  }

  const loadReport = (params) => {
    setReportCode(params.code)
    setReportParams(params)
  }
  useEffect(() => {
    const handleHashChange = () => {
      const hashParams = wtHrefHashGetVars()

      if (!hashParams.hasOwnProperty('code')) {
        lzNotifyErrorMessageFromResult('Invalid code provided')
        return
      }

      loadReport(hashParams)
    }

    //call logged in api again to update user (user rights)
    const authToken = wtGetFromLocalStorage('authToken', '')
    if (authToken !== null && authToken !== '' && typeof authToken !== 'undefined') {
      wtLoadLoggedInData()
    }

    handleHashChange()
    window.addEventListener('hashchange', handleHashChange)

    return () => {
      window.removeEventListener('hashchange', handleHashChange)
    }
  }, [])
  return (
    <div>
      <CToaster placement="top-end">
        {errorMessages.length > 0 &&
          errorMessages.map((eMsg, eDex) => (
            <CToast
              animation={true}
              autohide={true}
              visible={true}
              key={eDex}
              color="danger"
              onClick={() => discardErrorMsg(eDex)}
            >
              <CToastBody className="text-white">
                <CToastClose className="me-2 m-auto" white style={{ float: 'right' }} />
                <h4>
                  <strong>Error!</strong>
                </h4>
                {eMsg}
              </CToastBody>
            </CToast>
          ))}

        {successMessages.length > 0 &&
          successMessages.map((eMsg, eDex) => (
            <CToast key={eDex} animation={true} autohide={true} visible={true} color="success">
              <CToastBody className="text-white">
                <CToastClose
                  className="me-2 m-auto"
                  white
                  style={{ float: 'right' }}
                  onClick={() => discardSuccessMsg(eDex)}
                />
                <h4>
                  <strong>Success!</strong>
                </h4>
                {eMsg}
              </CToastBody>
            </CToast>
          ))}
      </CToaster>
      {authToken !== '' && authToken !== null ? (
        <>
          {'employee-data-report' === reportCode && <EmployeeDataReport {...reportParams} />}
          {'designation-tracking-report' === reportCode && (
            <DesignationTrackingReport {...reportParams} />
          )}
          {'employees-hierarchy' === reportCode && <EmployeeHierarchy {...reportParams} />}
          {'employee-detailed-data-report' === reportCode && (
            <EmployeeDetailedDataReport {...reportParams} />
          )}
          {'internship-report' === reportCode && <InternshipReport {...reportParams} />}
          {'hr-dashboard' === reportCode && (
            <Suspense fallback={Loading}>
              <HRDashboard {...reportParams} />
            </Suspense>
          )}
          {'employee-on-move-report' === reportCode && <EmployeeOnMoveReport {...reportParams} />}
          {'employee-attendance-report' === reportCode && (
            <EmployeeAttendanceReport {...reportParams} />
          )}
          {'employee-attendance-difference-report' === reportCode && (
            <EmployeeAttendanceDifferenceReport {...reportParams} />
          )}
          {'employee-late-coming-report' === reportCode && (
            <EmployeeLateComingReport {...reportParams} />
          )}
          {'employee-early-going-report' === reportCode && (
            <EmployeeEarlyGoingReport {...reportParams} />
          )}
          {'overtime-report' === reportCode && <OvertimeReport {...reportParams} />}
          {'employee-performance-evaluation-report' === reportCode && (
            <EmployeePerformanceEvaluationReport {...reportParams} />
          )}
          {'employee-attendance-analysis-report' === reportCode && (
            <AttendanceAnalysisReport {...reportParams} />
          )}
          {'employee-attendance-analysis-officers-report' === reportCode && (
            <AttendanceAnalysisOfficersReport {...reportParams} />
          )}
          {'employee-leave-report' === reportCode && <LeaveReport {...reportParams} />}

          {'trial-balance' === reportCode && <TrialBalance {...reportParams} />}
          {'trial-balance-v2' === reportCode && <TrailBalanceV2 {...reportParams} />}
          {'account-statement' === reportCode && <AccountStatement {...reportParams} />}
          {'balance-sheet' === reportCode && <BalanceSheet {...reportParams} />}

          {'profit-and-loss' === reportCode && <ProfitAndLoss {...reportParams} />}

          {'profit-and-loss-v2' === reportCode && <ProfitAndLossVersion2 {...reportParams} />}

          {'profit-and-loss-surcharge' === reportCode && (
            <ProfitAndLossSurcharge {...reportParams} />
          )}

          {'group-balances' === reportCode && <GroupBalance {...reportParams} />}

          {'employee-performance-details-report' === reportCode && (
            <EmployeePerformanceEvaluationDetailedReport {...reportParams} />
          )}
          {'vehicle-log-report' === reportCode && <VehicleLogReport {...reportParams} />}
          {'employee-family-details-report' === reportCode && (
            <EmployeeFamilyDetailReport {...reportParams} />
          )}
          {'employee-leave-detail-report' === reportCode && (
            <EmployeeLeaveDetailReport {...reportParams} />
          )}
          {'employee-evaluation-summary-report' === reportCode && (
            <EvaluationSummaryReport {...reportParams} />
          )}
          {'vehicle-tracking-report' === reportCode && <VehicleTrackingReport {...reportParams} />}
          {'hr-report' === reportCode && <HrReport {...reportParams} />}
          {'employee-absent-report' === reportCode && <EmployeeAbsentReport {...reportParams} />}
          {'opd-report' === reportCode && <OpdReport {...reportParams} />}

          {'salary-payment-report' === reportCode && <SalaryPaymentReport {...reportParams} />}
          {'wppf-report' === reportCode && <WppfReport {...reportParams} />}

          {'vehicle-tracking-details-report' === reportCode && (
            <VehicleTrackingDetailsReport {...reportParams} />
          )}

          {'finance-dashboard' === reportCode && <FinanceDashboard {...reportParams} />}

          {'management-dashboard' === reportCode && <ManagementDashboard {...reportParams} />}
          {'visitors-dashboard' === reportCode && (
            <VisitorsManagementDetailDashboard {...reportParams} />
          )}
          {'visitors-report' === reportCode && <VisitorsReport {...reportParams} />}
          {'bonus-report' === reportCode && <EmployeeBonusOnMeritReport {...reportParams} />}

          {'joining-report' === reportCode && <JoiningReport {...reportParams} />}

          {'leaving-report' === reportCode && <LeavingReport {...reportParams} />}
          {'contract-expiry-report' === reportCode && <ContractExpiryReport {...reportParams} />}
          {'gross-profit-sheet' === reportCode && <GrossProfitSheet {...reportParams} />}
          {'gp-report' === reportCode && <GpReport {...reportParams} />}

          {'bank-balance' === reportCode && <BankBalanceReport {...reportParams} />}
          {'income-tax-report' === reportCode && <IncomeTaxReport {...reportParams} />}

          {'cash-flow-statement' === reportCode && <CashFlowStatement {...reportParams} />}

          {'stock-adjustment-report' === reportCode && (
            <StockAdjustmentReport {...reportParams} />
          )}

          {'sales-target-report' === reportCode && <SalesTargetReport {...reportParams} />}

          {'outlet-expense-report' === reportCode && <OutletExpenseReport {...reportParams} />}

          {'jv-report' === reportCode && <JVReport {...reportParams} />}

          {'untagged-receipts-report' === reportCode && (
            <UntaggedReceiptsReport {...reportParams} />
          )}

          {'project-cash-flow' === reportCode && <ProjectCashFlow {...reportParams} />}

          {'sale-order-report' === reportCode && <SaleOrderReport {...reportParams} />}

          {'sale-order-detail-report' === reportCode && <SaleOrderDetailReport {...reportParams} />}

          {'sale-order-delivery-report' === reportCode && (
            <SaleOrderDeliveryReport {...reportParams} />
          )}

          {'sale-order-delivery-detail-report' === reportCode && (
            <SaleOrderDeliveryDetailReport {...reportParams} />
          )}

          {'ratio-analysis' === reportCode && <RatioAnalysis {...reportParams} />}
          {'ratio-analysis-v1' === reportCode && <RatioAnalysisV1 {...reportParams} />}
          {'cheque-signing-report' === reportCode && <ChequeSigningReport {...reportParams} />}

          {'sales-dashboard' === reportCode && <SalesDashboard {...reportParams} />}

          {'employee-salaries-report' === reportCode && (
            <EmployeeSalariesReport {...reportParams} />
          )}

          {'debtors-report' === reportCode && <DebtorsReport {...reportParams} />}

          {'stock-report' === reportCode && <StockReport {...reportParams} />}

          {'outlet-wise-stock-report' === reportCode && <OutletWiseStockReport {...reportParams} />}

          {'stock-serial-delivery-comparison-report' === reportCode && (
            <StockSerialDeliveryComparisonReport {...reportParams} />
          )}

          {'item-serial-report' === reportCode && <ItemSerialReport {...reportParams} />}

          {'item-barcodes' === reportCode && <ItemBarcodes {...reportParams} />}

          {'employee-warning-report' === reportCode && <EmployeeWarningReport {...reportParams} />}

          {'employee-training-report' === reportCode && (
            <EmployeeTrainingReport {...reportParams} />
          )}

          {'employee-transfer-report' === reportCode && (
            <EmployeeTransferReport {...reportParams} />
          )}

          {'branch-tracking-report' === reportCode && <BranchTrackingReport {...reportParams} />}
          {'talent-pool-report' === reportCode && <TalentPoolReport {...reportParams} />}

          {'project-detail-report' === reportCode && <ProjectDetailReport {...reportParams} />}
          {'cwip-classification-project-detail-report' === reportCode && (
            <CwipClassificationProjectDetailReport {...reportParams} />
          )}

          {'sale-book-report' === reportCode && <SaleBookReport {...reportParams} />}

          {'sale-summary-report' === reportCode && <SaleSummaryReport {...reportParams} />}

          {'stock-detailed-report' === reportCode && <StockDetailedReport {...reportParams} />}

          {'stock-aging-report' === reportCode && <StockAgingReport {...reportParams} />}

          {'stock-aging-report-v2' === reportCode && <StockAgingReportV2 {...reportParams} />}

          {'item-issuance-report' === reportCode && <ItemIssuanceReport {...reportParams} />}

          {'grn-report' === reportCode && <GrnReport {...reportParams} />}
          
          {'sale-order-invoice-detail-report' === reportCode && <SaleOrderInvoiceDetailReport {...reportParams} />}

          {'stock-movement-summary-report' === reportCode && <StockMovementSummaryReport {...reportParams} />}

          {'item-report' === reportCode && <ItemReport {...reportParams} />}

          {'internal-requisition-report' === reportCode && (
            <InternalRequisitionReport {...reportParams} />
          )}

          {'parties-report' === reportCode && <PartiesReport {...reportParams} />}

          {'item-ledger-report' === reportCode && <ItemLedgerReport {...reportParams} />}

          {'customer-ledger-report' === reportCode && <CustomerLedgerReport {...reportParams} />}
          {'members-report' === reportCode && <MembersReport {...reportParams} />}
          {'shooting-monthly-invoice-report' === reportCode && <ShootingMonthlyInvoiceReport {...reportParams} />}
        </>
      ) : (
        <Navigate to={'/login'} />
      )}
    </div>
  )
}

Reports.propTypes = {
  authToken: PropTypes.string,
}
